import "@formatjs/intl-durationformat/polyfill";

import { Provider as UrqlProvider } from "@urql/solid";
import { Suspense } from "solid-js";
import { ErrorBoundary } from "./components/errorBoundary";
import { TopAlertProvider } from "./components/ui/topAlert";
import { urqlClient } from "./lib/gql/urql";
import { KeyboardProvider, useKeyboard } from "./lib/keyboard";
import { Stack } from "./stackflow";

// Check entry-server.tsx for preloading
// Note. If you change the font here, you must also change it in entry-server.tsx
import "@fontsource-variable/inter";
import "@fontsource-variable/unbounded";

import "@contentstech/stackflow-plugin-basic-ui/index.css";
import "@unocss/reset/tailwind.css";
import "uno.css";
import "./styles/global.css";

import { QueryClient, QueryClientProvider } from "@tanstack/solid-query";
import { onMount } from "solid-js";

// TODO: Factor out
export const solidQueryClient = new QueryClient();

declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    dataLayer: any;
    gtag: (command: string, eventName: string, params?: Record<string, unknown>) => void;
  }
}

export default function App() {
  // TODO: Migrate to the entry-client.tsx to unify the analytics setup
  onMount(() => {
    const GA_ID = import.meta.env.VITE_GA_ID;
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        // biome-ignore lint/style/noArguments: <explanation>
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      // @ts-expect-error ignored
      gtag("js", new Date());
      // @ts-expect-error ignored
      gtag("config", GA_ID, {
        send_page_view: true,
      });
    };

    script.onerror = (err) => {
      console.error("GA script failed to load:", err);
    };

    document.head.appendChild(script);
  });

  return (
    <ErrorBoundary>
      <Suspense>
        <UrqlProvider value={urqlClient}>
          <QueryClientProvider client={solidQueryClient}>
            <TopAlertProvider>
              <KeyboardProvider>
                {(() => {
                  const keyboard = useKeyboard();
                  return (
                    <div
                      class="relative"
                      style={{
                        height: `calc(100dvh - ${keyboard.height()}px)`,
                      }}
                    >
                      <Stack transition={false} />
                    </div>
                  );
                })()}
              </KeyboardProvider>
            </TopAlertProvider>
          </QueryClientProvider>
        </UrqlProvider>
      </Suspense>
    </ErrorBoundary>
  );
}
